import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	issueAnalysis: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.issue-analysis',
		defaultMessage: 'Issue analysis',
		description: 'Issue analysis links group title',
	},
	averageAge: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.average-age',
		defaultMessage: 'Average Age Report',
		description: 'Average age report link item',
	},
	createdResolvedIssues: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.created-resolved-issues',
		defaultMessage: 'Created vs Resolved Issues Report',
		description: 'Created vs resolved issues report link item',
	},
	pieChart: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.pie-chart',
		defaultMessage: 'Pie Chart Report',
		description: 'Pie chart link item',
	},
	recentlyCreatedIssues: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.recently-created-issues',
		defaultMessage: 'Recently Created Issues Report',
		description: 'Recently created issues link item',
	},
	resolutionTime: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.resolution-time',
		defaultMessage: 'Resolution Time Report',
		description: 'Resolution time report link item',
	},
	singleLevelGroup: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.single-level-group',
		defaultMessage: 'Single Level Group By Report',
		description: 'Single level group by report link item',
	},
	timeSinceIssues: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.time-since-issues',
		defaultMessage: 'Time Since Issues Report',
		description: 'Time since issues link item',
	},
	issueAnalysisIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.issue-analysis-issue-term-refresh',
		defaultMessage: 'Work item analysis',
		description: 'Issue analysis links group title',
	},
	createdResolvedIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.created-resolved-issues-issue-term-refresh',
		defaultMessage: 'Created vs Resolved Work items Report',
		description: 'Created vs resolved issues report link item',
	},
	recentlyCreatedIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.recently-created-issues-issue-term-refresh',
		defaultMessage: 'Recently Created Work items Report',
		description: 'Recently created issues link item',
	},
	timeSinceIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.issue-analysis.time-since-issues-issue-term-refresh',
		defaultMessage: 'Time Since Work Report',
		description: 'Time since issues link item',
	},
});
